import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { debounceTime, tap } from "rxjs/operators";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { CarWorkshopService } from "@core/services";

type Network = {
  concept: "NETWORK";
  id: number;
  name: string;
};

@Component({
    selector: "app-driveb-multiple-network-autocomplete",
    templateUrl: "./multiple-network-autocomplete.component.html",
    styleUrls: ["./multiple-network-autocomplete.component.scss"],
    standalone: false
})
export class MultipleNetworkAutocompleteComponent implements OnInit {
  @ViewChild("tagInput") tagInput: ElementRef<HTMLInputElement>;

  networksList: Network[] = [];
  filteredNetworks: Network[] = [];
  form = new UntypedFormControl();
  loading = false;
  selectedNetworksName: string[] = [];

  @Output() onNetworkSelection = new EventEmitter<string[]>();

  constructor(
    private carWorkshopService: CarWorkshopService,
    private loadingDrivebService: LoadingDrivebService
  ) {}

  ngOnInit() {
    this.getNetworksName();
    this.form.valueChanges
      .pipe(
        debounceTime(200),
        tap(() => (this.loading = true))
      )
      .subscribe((value) => {
        this.filteredNetworks = this.getFilteredNetworksName(value);
        this.loading = false;
      });
  }

  getFilteredNetworksName(name: string) {
    const networkNameSearch = name.toLowerCase().trim();
    return this.networksList.filter((network) => {
      return (
        !this.selectedNetworksName.includes(network.name) &&
        network.name.toLowerCase().includes(networkNameSearch)
      );
    });
  }

  getNetworksName() {
    this.loading = true;
    this.loadingDrivebService.setAutoMode(false);
    this.carWorkshopService.getNetworkName({ concept: "NETWORK" }).subscribe(
      (networks) => {
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
        this.networksList = networks;
        this.filteredNetworks = networks;
      },
      () => {
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
      }
    );
  }

  remove(network: any) {
    const index = this.selectedNetworksName.indexOf(network);
    if (index < 0) return;
    this.selectedNetworksName.splice(index, 1);
    this.onNetworkSelection.emit(this.selectedNetworksName);
  }

  onSelectionNetwork($event: MatOptionSelectionChange, networkName: string) {
    if (!$event.isUserInput) return;
    this.selectedNetworksName.push(networkName);
    this.tagInput.nativeElement.value = "";
    this.onNetworkSelection.emit(this.selectedNetworksName);
  }
}
